const url = new URL(window.location.href);
const currentFilter = url.searchParams.get('filter');
var activeBTN;

if (currentFilter != null) {
    switch(currentFilter) {
        case "history":
            activeBTN = "historyBTN";
            filterSelection(currentFilter);
            break;
        case "teaPrep":
            activeBTN = "teaPrepBTN";
            filterSelection(currentFilter);
            break;
        case "teaBasics":
            activeBTN = "teaBasicsBTN";
            filterSelection(currentFilter);
            break;
        default:
            activeBTN = "allBTN";
            filterSelection("all");

    }

    var current = document.getElementsByClassName("active");
    current[0].className = current[0].className.replace(" active", "");


    var newActive = document.getElementsByClassName(activeBTN);
    newActive[0].className += " active";

}
else {
    filterSelection("all");
}

function filterSelection(c) {
    var x, i;
    x = document.getElementsByClassName("filterDiv");
    if (c == "all") c = "";
    // Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
    for (i = 0; i < x.length; i++) {
        w3RemoveClass(x[i], "show101");
        if (x[i].className.indexOf(c) > -1) w3AddClass(x[i], "show101");
    }

}

// Show filtered elements
function w3AddClass(element, name) {
    var i, arr1, arr2;
    arr1 = element.className.split(" ");
    arr2 = name.split(" ");
    for (i = 0; i < arr2.length; i++) {
        if (arr1.indexOf(arr2[i]) == -1) {
            element.className += " " + arr2[i];
        }
    }
}

// Hide elements that are not selected
function w3RemoveClass(element, name) {
    var i, arr1, arr2;
    arr1 = element.className.split(" ");
    arr2 = name.split(" ");
    for (i = 0; i < arr2.length; i++) {
        while (arr1.indexOf(arr2[i]) > -1) {
            arr1.splice(arr1.indexOf(arr2[i]), 1);
        }
    }
    element.className = arr1.join(" ");
}

// Add active class to the current control button (highlight it)
var btnContainer = document.getElementById("myBtnContainer");
var btns = btnContainer.getElementsByClassName("btn");
for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", function() {
        var current = document.getElementsByClassName("active");
        current[0].className = current[0].className.replace(" active", "");
        this.className += " active";
    });
}